export default {"src":"/_next/static/media/ic-ticked.b926c314.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};